export const maxSubmenuHeight = 5;
export const menuItemHeight = 40;
export const footerHeight = 80;
export const numFieldsPerTab = 10;
export const maxFreezeIndex = 4;

export const ReloadMode = {
    ROW: 'P',
    TABLE: 'R',
    ACTIONS: 'Q'
};

export enum ActionsSubtitleType {
    quickAccess = 'quickAccess',
    actionsList = 'actionsList'
}
